export default __webpack_public_path__ + "static/media/toolkitBlue.efbd13fa.svg";